export default __webpack_public_path__ + "static/media/mail.2f72c7dd.png";